import angular from 'angular';
import * as LDClient from 'launchdarkly-js-client-sdk';

import '../controller/controller';
import { Storage } from './storage';
import { Country } from './country'
import { LAUNCH_DARKLY_CLIENT_SIDE_ID } from '../controller/environment'

// Given LDClient is `import`ed as above,
// jasmine's spies are powerless to affect it at all.
// Needed to add some extra level of indirection for testing 😬
angular.module("core.application.main").factory("launchDarkly", [
  function() {
    let client = LDClient;

    let expose = {};
    expose.getClient = () => client;

    return expose;
  }
]);

angular.module("core.application.main").factory("core.application.main.factory.feature", [
    "$rootScope",
    "launchDarkly",
    function($rootScope, LaunchDarkly) {
        // Documentation for Launch Darkly feature flags: https://docs.launchdarkly.com/docs/js-sdk-reference
        var ldConfig = {
            // Bootstrapping to localStorage will save the feature flag to storage,
            // this will speed up future calls - particularly when moving between routes
            bootstrap: "localStorage",
            // Don't send personally identifiable information to Launch Darkly
            // This still exposes the email address on the user's device browser
            // for Launch Darkly to evaluate any rules configured for the feature flags
            privateAttributeNames: ["email"]
        };
        var storedAnonymousUserKey = function(value) {
            return Storage.setLocalStorageItem("anonymousUserKey", value);
        };
        var anonymousUserKey = function() {
            var s = "00" + Math.floor(Math.random() * 1000);
            return "anonymous-" + s.substr(s.length-3);
        }
        var anonymousUser = {
            key: storedAnonymousUserKey() || storedAnonymousUserKey(anonymousUserKey()),
            anonymous: true,
            country: Country.getCountryCodeFromUrl(),
        };
        var storedUser = function(user) {
            // parameters: {
            //     key: uuidv4 for anonymous users or consumerId for identified users,
            //     email: test@test.com, (optional)
            //     country: "AU" (optional)
            //     anonymous: true/false (optional)
            // }
            return Storage.setSessionStorageItem("launchDarklyUser", user);
        };
        var clientUser = storedUser();
        clientUser = clientUser && clientUser.key ? clientUser : anonymousUser;
        var client = typeof LaunchDarkly.getClient() !== "undefined" && LaunchDarkly.getClient().initialize(
            LAUNCH_DARKLY_CLIENT_SIDE_ID,
            clientUser,
            ldConfig
        );
        client && client.on("ready", function() {
            $rootScope.$apply(function () {
                $rootScope.$broadcast("featureFlagsReady");
            });
        });

        var expose = {};
        expose.identify = function(user, callback) {
            // Switch from an anonymous user to the logged in user
            callback = callback || angular.noop;
            storedUser(user);
            if (client && user && user.key) {
                $rootScope.$broadcast("loadingFeatureFlag");
                client.identify(user, null, function() {
                    $rootScope.$apply(function () {
                        // Need to flush the request to ensure the identify happens straight away.
                        $rootScope.$broadcast("featureFlagsReady");
                        client.flush();
                        callback();
                    });
                });
            } else {
                $rootScope.$broadcast("featureFlagsReady");
                callback();
            }
        };

        // Allows targeting of features by email address before
        // a user is fully identified (authenticated).
        expose.identifyWithEmailPromise = function(email) {
            if(!email) {
                return Promise.resolve();
            }
            var user = storedUser() || anonymousUser;
            user.email = email;
            return new Promise(function (resolve) {
                expose.identify(user, resolve);
            });
        };

        expose.deIdentify = function(callback) {
            expose.identify(anonymousUser, callback);
        };

        expose.retrieveFeatureFlagPromise = function(featureFlagName, featureFlagFallback) {
            if (!client) {
                return Promise.resolve(featureFlagFallback);
            }
            return client.waitForInitialization().then(function() {
                return client.variation(featureFlagName, featureFlagFallback);
            }).catch(function() {
                return featureFlagFallback;
            });
        };

        expose.retrieveFeatureFlags = function(featureFlagsList) {
            if (!client) {
                return Promise.reject(new Error('Launch Darkly: client is not available'));
            }

            return client.waitForInitialization().then(function() {
                var launchDarklyPromises = featureFlagsList.map(function(flagName) {
                    return client.variation(flagName, false);
                });

                return Promise.all(launchDarklyPromises);
            }).catch(function() {
                return Promise.reject(new Error('Launch Darkly: something is wrong'));
            });
        };

        return expose;
    }
]);
